export default "__VITE_ASSET__BEDrJwUh__"